export const modalConstants = {
  update: 'update',
  delete: 'delete',
  create: 'create',
  createFinanceRole: 'createFinanceRole',
};

export const approvalTypes = [
  { label: 'Line Item Approval', value: 'lineitem_approval' },
  { label: 'PO Approval', value: 'po_approval' },
  { label: 'Invoice Approval', value: 'invoice_approval' },
  { label: 'Vendor Mapping', value: 'vendor_mapping' },
  { label: 'PR Approval', value: 'pr_approval' },

];

export const locationTypes = [
  { label: 'HO', value: 'HO' },
  { label: 'Store', value: 'STORE' },
];

export const workFlowTypes = [
  { label: 'Capex', value: 'capex' },
  {
    label: 'Opex',
    value: 'opex',
  },
];

export const MANDATORY_FIRST_STAGE = {
  stageName: 'Operational Head Approval',
  stageRoleName: 'Operational Head',
};

export const isStorePrApprovalConfig = (modalData) =>
  modalData?.approvalType === 'pr_approval' && modalData?.locationType === 'STORE';
